export const queryKeys = {
  positions: ["positions"] as const,
  matrices: (positionId?: number) => ["matrices", { positionId }] as const,
  candidates: (opts?: { positionId?: number; matrixId?: number; archived?: boolean }) =>
    ["candidates", opts] as const,
  candidateStages: (candidateId: number) => ["candidates", candidateId, "stages"] as const,
  candidateProfile: (candidateId: number) => ["candidate-profile", candidateId] as const,
  candidateSalary: (candidateId: number) => ["candidates", candidateId, "salary"] as const,
  events: (opts?: { entityType?: string; entityId?: number; eventType?: string }) =>
    ["events", opts] as const,
  users: ["users"] as const,
  roles: ["roles"] as const,
  orgRoles: (orgId: number) => ["org-roles", orgId] as const,
  organizations: ["organizations"] as const,
  orgAnalytics: (orgId: number, period: string, startDate: string) => ["org-analytics", orgId, period, startDate] as const,
  notes: (candidateId: number) => ["notes", candidateId] as const,
  interviews: (candidateId?: number) => ["interviews", candidateId ?? "all"] as const,
};
